export default __webpack_public_path__ + "static/media/Example-Invoices.a124f034.png";